import styled from 'styled-components';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

const Root = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ContentWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const Text = styled.div`
    margin-top: 40px;
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
    text-align: center;
    width: 80%;
`;

const Loader = styled(CircleLoader)`
    height: auto;
    flex-grow: 0;
`;

export {
    Root,
    ContentWrapper,
    Text,
    Loader,
}
